const URL = process.env.NODE_ENV === 'production' ? 'https://grupoeuromotors.online:447/' : 'http://localhost:8000/';
export default URL; 